module.exports = __webpack_public_path__ + "static/img/c3x2.c7a6b5ee.png";